import AnimatedIcon from "./AnimatedIcon";

const IconPeople = ({ className = "", isOpen, hideText, delay = 0, labelPos = "l" }) => (
  <AnimatedIcon
    className={className}
    isOpen={isOpen}
    hideText={hideText}
    delay={delay}
    labelPos={labelPos}
    svgIcon={
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 178.85 178.85">
            <g fill="none">
            <circle cx="89.42" cy="89.42" r="61.99"></circle>
            <g stroke="#fff" strokeMiterlimit="10" strokeWidth="3.797">
                <circle cx="135.08" cy="89.17" r="11.11"></circle>
                <path d="M178.85 67.6h-5.42a16.81 16.81 0 0 0-16.81 16.8v10a16.81 16.81 0 0 0 16.81 16.81h5.42"></path>
            </g>
            <g stroke="#fff" strokeMiterlimit="10" strokeWidth="3.797">
                <circle cx="43.77" cy="89.68" r="11.11"></circle>
                <path d="M0 111.25h5.42a16.81 16.81 0 0 0 16.81-16.81v-10A16.81 16.81 0 0 0 5.42 67.6H0"></path>
            </g>
            <g stroke="#fff" strokeMiterlimit="10" strokeWidth="3.797">
                <circle cx="121.53" cy="56.96" r="11.11"></circle>
                <path d="m137.22 10.76-3.83 3.83a16.82 16.82 0 0 0 0 23.77l7.1 7.1a16.82 16.82 0 0 0 23.77 0l3.83-3.83"></path>
            </g>
            <g stroke="#fff" strokeMiterlimit="10" strokeWidth="3.797">
                <circle cx="57.32" cy="121.89" r="11.11"></circle>
                <path d="m41.63 168.09 3.83-3.83a16.82 16.82 0 0 0 0-23.77l-7.1-7.1a16.82 16.82 0 0 0-23.77 0l-3.83 3.83"></path>
            </g>
            <g stroke="#fff" strokeMiterlimit="10" strokeWidth="3.797">
                <circle cx="89.17" cy="43.77" r="11.11"></circle>
                <path d="M67.6 0v5.42a16.81 16.81 0 0 0 16.8 16.81h10a16.81 16.81 0 0 0 16.85-16.81V0"></path>
            </g>
            <g stroke="#fff" strokeMiterlimit="10" strokeWidth="3.797">
                <circle cx="89.68" cy="135.08" r="11.11"></circle>
                <path d="M111.25 178.85v-5.42a16.81 16.81 0 0 0-16.81-16.81h-10a16.81 16.81 0 0 0-16.8 16.81v5.42"></path>
            </g>
            <g stroke="#fff" strokeMiterlimit="10" strokeWidth="3.797">
                <circle cx="56.96" cy="57.32" r="11.11"></circle>
                <path d="m10.76 41.63 3.83 3.83a16.82 16.82 0 0 0 23.77 0l7.1-7.1a16.82 16.82 0 0 0 0-23.77l-3.83-3.83"></path>
            </g>
            <g stroke="#fff" strokeMiterlimit="10" strokeWidth="3.797">
                <circle cx="121.89" cy="121.53" r="11.11"></circle>
                <path d="m168.09 137.22-3.83-3.83a16.82 16.82 0 0 0-23.77 0l-7.1 7.1a16.82 16.82 0 0 0 0 23.77l3.83 3.83"></path>
            </g>
        </g>
    </svg>
    }
    text={
      <>
        <span className="whitespace-nowrap">Future-Proofed</span>
        <br /> Workplaces
      </>
    }
  />
);

export default IconPeople;